module.exports = __webpack_public_path__ + "img/btn_menu_setting.a95dcc86.svg";